var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { Col, Row } from "react-bootstrap";
import rateAdvisorimg from "../../../../../assets/images/features/BasicProfile/Rateadvisor.svg";
import starservice from "../../../../../assets/images/features/BasicProfile/star-service.svg";
import businessman from "../../../../../assets/images/features/BasicProfile/businessman.svg";
import advice from "../../../../../assets/images/features/BasicProfile/advice.svg";
import clock from "../../../../../assets/images/features/BasicProfile/clock.svg";
import talking from "../../../../../assets/images/features/BasicProfile/talking.svg";
import others from "../../../../../assets/images/features/BasicProfile/others.svg";
import InputField from "@frameworks/web/components/generic/inputField";
import di from "@frameworks/web/components/features/BasicProfile/di/servicelocator";
import React, { useState } from "react";
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import { accountDetails } from "../../../../../../../mainDi/webDi";
import { reject } from "underscore";
export var RateAdvisorData = [
    { title: "6-star service", value: "6-star service", img: starservice },
    {
        title: "Extremely professional",
        value: "Extremely professional",
        img: businessman,
    },
    { title: "Expert Advice", value: "Expert Advice", img: advice },
    { title: "Great execution", value: "Great execution", img: clock },
    {
        title: "Excellent communication",
        value: "Excellent communication",
        img: talking,
    },
    { title: "Others", value: "Others", img: others },
];
export var wentWrongData = [
    { title: "Quality of Advice", value: "Quality of Advice", img: starservice },
    {
        title: "Professionalism",
        value: "Professionalism",
        img: businessman,
    },
    {
        title: "Execution of Requests",
        value: "Execution of Requests",
        img: advice,
    },
    {
        title: "Timely Update & Communication",
        value: "Timely Update & Communication",
        img: talking,
    },
    { title: "Other Reasons", value: "Others", img: others },
];
var RmRatingPop = function (props) {
    var inputfield = {
        feedback: "",
    };
    var accData = JSON.parse(localStorage.getItem("acc_data"));
    var _a = __read(useState(1), 2), ratingCount = _a[0], setRatingCount = _a[1];
    var _b = __read(useState(inputfield), 2), formData = _b[0], setFormData = _b[1];
    var _c = __read(useState([]), 2), selectedTagsList = _c[0], setSelectedTagsList = _c[1];
    var _d = __read(useState(false), 2), showTextarea = _d[0], setShowTextarea = _d[1];
    var Star = function () {
        return (React.createElement(React.Fragment, null, __spreadArray([], __read(Array(5)), false).map(function (item, index) {
            var givenRating = index + 1;
            return (React.createElement("label", { className: "star-block-label" },
                React.createElement("input", { type: "radio", value: givenRating, onClick: function () {
                        setRatingCount(givenRating);
                    } }),
                React.createElement("span", { className: givenRating < ratingCount || givenRating === ratingCount
                        ? "edel-icon-star-filled"
                        : "edel-icon-star-unfilled" })));
        })));
    };
    var toggleSelectedTags = function (index) {
        var selectedTags = [];
        if (RateAdvisorData[index].value == "Others" ||
            wentWrongData[index].value == "Others") {
            if ((selectedTagsList === null || selectedTagsList === void 0 ? void 0 : selectedTagsList.indexOf(index)) == -1) {
                setShowTextarea(true);
            }
            else {
                setShowTextarea(false);
            }
        }
        if (selectedTagsList.indexOf(index) > -1) {
            selectedTags = selectedTagsList.filter(function (tag) { return tag !== index; });
        }
        else {
            selectedTags = __spreadArray(__spreadArray([], __read(selectedTagsList), false), [index], false);
        }
        setSelectedTagsList(selectedTags);
    };
    var feedbackChange = function (event) {
        var _a;
        setFormData(__assign(__assign({}, formData), (_a = {}, _a[event.target.name] = event.target.value, _a)));
    };
    var advisorratingSubmit = function () { return __awaiter(void 0, void 0, void 0, function () {
        var payload;
        var _a;
        var _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _a = {
                        advType: props === null || props === void 0 ? void 0 : props.advTyp,
                        rt: ratingCount,
                        fbTxt: formData.feedback ? formData.feedback : ""
                    };
                    return [4 /*yield*/, (accountDetails === null || accountDetails === void 0 ? void 0 : accountDetails.getPreferedAccountCodeID())];
                case 1:
                    _a.accCode = (_b = (_d.sent())) === null || _b === void 0 ? void 0 : _b.accCode,
                        _a.compLst = ratingCount > 3
                            ? selectedTagsList
                                .map(function (tag) {
                                return RateAdvisorData[tag].value.replace(/<br\s*\/>/g, " ");
                            })
                                .join(";")
                            : null,
                        _a.prsNt = ratingCount === 5 ? formData.feedback : "",
                        _a.fbLst = ratingCount <= 3
                            ? selectedTagsList
                                .map(function (tag) { return wentWrongData[tag].value.replace(/<br\s*\/>/g, " "); })
                                .join(";")
                            : null;
                    return [4 /*yield*/, accountDetails.getAccTyp()];
                case 2:
                    payload = (_a.accTyp = (_d.sent()) || "EQ",
                        _a.src = "EWIN",
                        _a.sts = "S",
                        _a);
                    (_c = di === null || di === void 0 ? void 0 : di.basicProfile) === null || _c === void 0 ? void 0 : _c.advisorRatingDetailsData(payload).then(function () {
                        var _a;
                        props === null || props === void 0 ? void 0 : props.setShowToast(true);
                        props === null || props === void 0 ? void 0 : props.setshowRMName(props === null || props === void 0 ? void 0 : props.Name);
                        (_a = di === null || di === void 0 ? void 0 : di.basicProfile) === null || _a === void 0 ? void 0 : _a.getRmDetailsData();
                    }).catch(function (err) {
                        reject(err);
                    });
                    props.setShow(false);
                    return [2 /*return*/];
            }
        });
    }); };
    return (React.createElement(React.Fragment, null,
        React.createElement(Row, { className: "rateAdvisor-main" },
            React.createElement(Col, { lg: 12, className: "rateadvisor-section mb-txt-center" },
                React.createElement("div", null,
                    React.createElement("img", { src: rateAdvisorimg })),
                React.createElement("div", null,
                    React.createElement("span", { className: "DMSansBold_20_700 txt_blackOne1 d-flex mb-txt-center" }, props.Name),
                    React.createElement("span", { className: "d-flex start-icon mb-txt-center" },
                        React.createElement(Star, null)),
                    React.createElement("span", { className: "DMSan_16_700 txt_primaryGrey mb-txt-center" }, ratingCount === 1
                        ? "Very unhappy"
                        : ratingCount === 2
                            ? "Unhappy"
                            : ratingCount === 3
                                ? "Average"
                                : ratingCount === 4
                                    ? "Glad you liked it!"
                                    : "Glad to have made you smile!"))),
            React.createElement(Col, { lg: 12, className: "mgt-20" },
                React.createElement("div", { className: "feedback-section text-center" },
                    React.createElement("span", { className: "DMSans_16_500 txt_primaryGrey" },
                        "Give ",
                        props.Name,
                        " your feedback"),
                    React.createElement("div", { className: "feedback-grid mt-20" }, ratingCount > 0 && ratingCount > 3 ? (React.createElement(React.Fragment, null, RateAdvisorData === null || RateAdvisorData === void 0 ? void 0 : RateAdvisorData.map(function (data, idx) {
                        return (React.createElement(React.Fragment, null,
                            React.createElement("button", { className: "grid-1 justify-content-center border-box ".concat(selectedTagsList.indexOf(idx) > -1
                                    ? "bg_aqua_white brd-midnight-blue"
                                    : "bg_white"), key: idx, onClick: function (e) { return toggleSelectedTags(idx); } },
                                React.createElement("span", null,
                                    React.createElement("img", { src: data.img })),
                                React.createElement("div", { className: "mt-10 DMSansMedium_12_500 txt_primaryGrey" }, data.title))));
                    }))) : (React.createElement(React.Fragment, null, wentWrongData === null || wentWrongData === void 0 ? void 0 : wentWrongData.map(function (data, idx) {
                        return (React.createElement(React.Fragment, null,
                            React.createElement("button", { className: "grid-1 justify-content-center border-box ".concat(selectedTagsList.indexOf(idx) > -1
                                    ? "bg_aqua_white brd-midnight-blue"
                                    : "bg_white"), key: idx, onClick: function (e) { return toggleSelectedTags(idx); } },
                                React.createElement("span", null,
                                    React.createElement("img", { src: data.img })),
                                React.createElement("div", { className: "mt-10 DMSansMedium_12_500 txt_primaryGrey" }, data.title))));
                    })))))),
            showTextarea && (React.createElement(Col, { lg: 12, className: "mgt-15" },
                React.createElement(InputField, { onChangeEvent: function (e) { return feedbackChange(e); }, placeholder: "Give your feedback here.", id: "feedback", name: "feedback", placeholderClassName: "" }))),
            React.createElement("div", { className: "pt-4 pb-4" },
                React.createElement(EdButton, { btnTyp: "midnight-blue", className: "w-100", value: "Submit", disabled: !(selectedTagsList === null || selectedTagsList === void 0 ? void 0 : selectedTagsList.length), onClick: function () {
                        advisorratingSubmit();
                    } })))));
};
export default RmRatingPop;
